import { apiService } from "../../app.service";

export const restaruantapi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchRestaurantData: builder.query({
      query: () => ({
        url: "/admin/restaurants",
      }),
      providesTags: ["restaurants"],
    }),
    fetchRestaurantDataById: builder.query({
      query: (id) => ({
        url: `/admin/restaurants/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "restaurant", id: result._id }] : [],
    }),
    fetchSelfRestaurantData: builder.query({
      query: () => ({
        url: `/admin/restaurants/self`,
      }),
    }),
    addRestaurantData: builder.mutation({
      query: (data) => ({
        url: "/admin/restaurants",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["restaurants"],
    }),
    editRestaurantData: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/restaurants/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "restaurant", id },
        "restaurants",
      ],
    }),
    deleteRestaurantData: builder.mutation({
      query: (data) => ({
        url: "/admin/restaurants/" + data,
        method: "DELETE",
      }),
      invalidatesTags: ["restaurants"],
    }),
    getRestaurantChecklistDuetime: builder.query({
      query: () => ({
        url: "/user/restaurant/due-time",
      }),
      providesTags: ["restaurantChecklistDuetime"],
    }),
    setRestaurantChecklistDuetime: builder.mutation({
      query: ({ type, data }) => ({
        url: `/user/restaurant/due-time/${type}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["restaurantChecklistDuetime"],
    }),
    getRestaurantIncidentDuetime: builder.query({
      query: () => ({
        url: "/user/restaurant/incident-due-time",
      }),
      providesTags: ["restaurantIncidentDuetime"],
    }),
    setRestaurantIncidentDuetime: builder.mutation({
      query: (data) => ({
        url: "/user/restaurant/incident-due-time",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["restaurantIncidentDuetime"],
    }),
    updateRestaurantSetting: builder.mutation({
      query: (data) => ({
        url: "/admin/restaurants/self",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "restaurant", id }],
    }),
  }),
});

export const {
  useAddRestaurantDataMutation,
  useFetchRestaurantDataQuery,
  useDeleteRestaurantDataMutation,
  useFetchRestaurantDataByIdQuery,
  useEditRestaurantDataMutation,
  useGetRestaurantChecklistDuetimeQuery,
  useSetRestaurantChecklistDuetimeMutation,
  useGetRestaurantIncidentDuetimeQuery,
  useSetRestaurantIncidentDuetimeMutation,
  useFetchSelfRestaurantDataQuery,
  useUpdateRestaurantSettingMutation,
} = restaruantapi;
